var $9a12ff1caae5a7a5$exports = {};
$9a12ff1caae5a7a5$exports = {
    "close": `Close`,
    "notifications": `Notifications`
};


export {$9a12ff1caae5a7a5$exports as default};
//# sourceMappingURL=en-US.module.js.map
